function createMemoryStorage(): Storage {
  const items = new Map<string, string>();

  return {
    get length() {
      return items.size;
    },
    key(index: number) {
      return Array.from(items.keys())[index] ?? null;
    },
    getItem(key: string) {
      return items.get(key) ?? null;
    },
    setItem(key: string, value: string) {
      items.set(key, String(value));
    },
    removeItem(key: string) {
      items.delete(key);
    },
    clear() {
      items.clear();
    }
  };
}

/**
 * Inertia keeps its history encryption key in session storage and does not handle the
 * `SecurityError` that a browser which blocks site data throws, so every navigation stops. Such a
 * browser gets a store that lasts for the current document, and logout still clears it.
 */
export function installSessionStorageFallback(): void {
  try {
    void window.sessionStorage.length;
  } catch (error) {
    if (!(error instanceof DOMException && error.name === 'SecurityError')) {
      throw error;
    }

    Object.defineProperty(window, 'sessionStorage', {
      configurable: true,
      value: createMemoryStorage()
    });
  }
}
